const tinycolor = require( 'tinycolor2' );

const defaultBranding = {
	primaryLogo: '',
	secondaryLogo: '',
	primaryColor: '#ccccccc',
	secondaryColor: '#ccccccc',
	supportingColor: '#ccccccc'
};

export default function( branding ) {
	const b = branding || defaultBranding;

	function hexToRgb( hex ) {
		let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec( hex );
		return result ? {
			r: parseInt( result[ 1 ], 16 ),
			g: parseInt( result[ 2 ], 16 ),
			b: parseInt( result[ 3 ], 16 )
		} : null;
	}

	const rgbPrimary = hexToRgb( b.primaryColor );

	const css = `
        .primary-logo { background-image: url("${ b.primaryLogo }"); }
        .secondary-logo { background-image: url("${ b.secondaryLogo }"); }

        .primary-color { color: ${ b.primaryColor }; }
        .secondary-color { color: ${ b.secondaryColor }; }
        .supporting-color { color: ${ b.supportingColor }; }

        .primary-background { background-color: ${ b.primaryColor }; }
        .secondary-background { background-color: ${ b.secondaryColor }; }
        .supporting-background { background-color: ${ b.supportingColor }; }

        .primary-border { border-color: ${ b.primaryColor }; }
        .secondary-border { border-color: ${ b.secondaryColor }; }
        .supporting-border { border-color: ${ b.supportingColor }; }

		.primary-border:hover { border-color: ${ b.primaryColor } !important; }
        .primary-hover:hover { color: ${ branding.primaryColor } !important; }
        .primary-highlight.highlighted {background-color: rgba( ${ rgbPrimary.r }, ${ rgbPrimary.g }, ${ rgbPrimary.b }, .05 ) !important; }
        .primary-highlight.ant-menu-item-selected {background-color: rgba( ${ rgbPrimary.r }, ${ rgbPrimary.g }, ${ rgbPrimary.b }, .05 ) !important; }
        .primary-highlight-hover:hover {background-color: rgba( ${ rgbPrimary.r }, ${ rgbPrimary.g }, ${ rgbPrimary.b }, .05 ) !important;}
        .primary-highlight:active {background-color: rgba( ${ rgbPrimary.r }, ${ rgbPrimary.g }, ${ rgbPrimary.b }, .05 ) !important; }
            
        .primary-outline { outline-color: ${ b.primaryColor }; }
        .secondary-outline { outline-color: ${ b.secondaryColor }; }
        .supporting-outline { outline-color: ${ b.supportingColor }; }
    `;

	b.theme = tinycolor( b.primaryColor ).isDark() ? 'dark' : 'light';

	const head = document.head || document.getElementsByTagName( 'head' ) [ 0 ];
	const body = document.body || document.getElementsByTagName( 'body' )[ 0 ];
	body.classList.add( b.theme );

	const style = document.createElement( 'style' );
	style.type = 'text/css';

	if ( style.styleSheet ) {
		style.styleSheet.cssText = css;
	} else {
		style.appendChild( document.createTextNode( css ) );
	}

	head.appendChild( style );

	return b;
}